export default __webpack_public_path__ + "static/media/arrow-right-blue.8fd9e89d.svg";